import { useEditorialSidePanelContext } from '@monofront/business/contexts';
import { useNavigationEventListener } from '@hooks/useNavigationEventListener';

export const SidePanelRouterEventListener = () => {
  const { setEditorialPanelSourceUid } = useEditorialSidePanelContext();

  useNavigationEventListener({
    cb: () => setEditorialPanelSourceUid(null),
  });

  return null;
};
